import React, { useState } from "react";
import { Button, Grid, Skeleton, Typography } from "@mui/material";
import Loader from "components/loader/Loader";
import clock from "assets/images/greyClock.svg";



function ChooseCab(props) {
  const [selectedItem, setSelectedItem] = useState(0);
  const [type, setType] = useState(props?.rateCalculationData ? props?.rateCalculationData?.[0]?.carType : 'Car');
  const [rateData, setRateData] = useState(props?.rateCalculationData?.[0]);
  const onClickCab = () => {
    props?.onClickCab(rateData)
  };
  const handleItemClick = (index, carType, data) => {
    setSelectedItem(index);
    setType(carType);
    setRateData(data);
  };
  const duration = (data) => {
    if (data?.eta || data?.time) {
      let totalMinutes = data.eta ? data.eta * 60 : 0; // Convert fractional hours to total minutes
      let hours = Math.floor(totalMinutes / 60); // Extract hours
      let minutes = Math.round(totalMinutes % 60); // Extract remaining minutes (rounded)
      return (
        <>
          <img className="hw16" src={clock} alt="clock" />
          {data?.time && `${data.time} hr `}
          {data?.eta &&
            `${hours > 0 ? `${hours} hr ` : ""}${minutes > 0 ? `${minutes} min` : ""}`}
        </>
      );
    }
    return null; // Return null if no time-related data is present
  };

  return (
    <Grid container>
      <Grid
        item
        container
        md={12}
        direction="column"
        spacing={2}
        className="marginLeft10 myRideMain"
      >
        <Grid item direction="column">
          <Typography className=" fontMedium">Choose Your Vehicle</Typography>
          {/* <Typography className="colorBlue fontSemi">Recommended</Typography> */}
        </Grid>
        <Grid item spacing={2} className={`${props?.rateCalculationData.length > 0 ? 'rightScroll' : ''}`}>


          {props?.rateCalculationData?.map((car, index) => (
            <Grid
              item
              container
              md={11}
              direction="row"
              justifyContent="space-around"
              alignItems="center"
              className={`cardDesign cursor  ${selectedItem === index ? "hoverBorder" : ""
                }`}
              key={index}
              onClick={() => handleItemClick(index, car?.carType, car)}
            >
              <Grid item md={3} className="justifyStart">
                <img src={car?.masterCarType?.avtar?.url || car?.carImg} alt="car" className="w90H45" />
              </Grid>
              <Grid item md={4}>
                <Grid item direction="column">
                  <Typography className="fontSemi">{car?.carType}</Typography>
                  <Typography className="font12 fw600 colorGrey dflex">
                    {parseFloat(car?.distance).toFixed(1)} km
                    <span className="justifyStart marginleft5">{duration(car)}</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item md={4} className="textAlignEnd fontBold font16">
                {"₹ " + Math.round(JSON.parse(car?.totalAmount))}
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid item className="alignTextCenter">
          <Button
            variant="contained"
            size="medium"
            fullWidth
            className="buttonEnabled"
            onClick={onClickCab}
          >

            {`Choose ${type}`}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ChooseCab;
